<template>
	<div class="user-management">
		<div class="container">
			<!-- Header -->
			<div class="page-header flex-center">
				<h1 class="page-title">Supplier Management</h1>
				<div class="page-header-right text-right ml-a">
					<!-- Date Filter -->
					<daterangepicker
						:presets="filterDatePresets"
						:start="since"
						:end="until"
						@selected="setFilterDate"
						ref="datePicker"
					>
					</daterangepicker>
				</div>
			</div>
			<div class="page-content">
				<!-- Table Menu -->
				<div class="table-list-menu">
					<div class="row">
						<div class="col-sm-6">
							<div class="table-actions flex-center" v-if="isAdmin">
								<button
									class="btn btn-primary btn-sm"
									@click="isShowCreateItem = true"
								>
									<i class="material-icons">add</i><span>Add New Supplier</span>
								</button>
								<div class="dropdown">
									<button
										class="btn btn-light btn-sm dropdown-toggle"
										:disabled="selectedItems.length === 0"
										data-toggle="dropdown"
										aria-haspopup="true"
										aria-expanded="false"
										v-tooltip="disabledTooltip"
									>
										Actions
									</button>
									<div class="dropdown-menu" v-if="selectedItems.length > 0">
										<!-- <div
											class="dropdown-item"
											@click="isShowChangePackage = true"
										>
											Change Package
										</div> -->
										<!-- <div
											class="dropdown-item"
											@click="isShowChangeExpiration = true"
										>
											Change Expiration
										</div> -->
										<button
											class="dropdown-item"
											@click="isShowChangeStatus = true"
										>
											Change Status
										</button>
										<!-- <div
											class="dropdown-item"
											@click="isShowChangePassword = true"
										>
											Change Password
										</div> -->
										<button
											class="dropdown-item"
											:class="{ 'disabled':selectedItems.length > 1 }"
											@click="openModalUpdateFeatures(selectedItems[0])">
											{{ $t('Update Features') }}
										</button>
										<button
											type="button"
											class="dropdown-item"
											@click="toggleStoreStatusModal(null, true, 'close', true)">
											{{ $t('Close Store') }}
										</button>
										<button
											type="button"
											class="dropdown-item"
											@click="toggleStoreStatusModal(null, true, 'open', true)">
											{{ $t('Open Store') }}
										</button>
										<button
											type="button"
											class="dropdown-item"
											@click="toggleProductStatusModal(null, true, 'suspend', true)">
											Suspend Products
										</button>
										<button
											type="button"
											class="dropdown-item"
											@click="toggleProductStatusModal(null, true, 'active', true)">
											Unsuspend Products
										</button>
									</div>
								</div>
								<button
									class="btn btn-light btn-sm btn-icon-danger"
									:class="{ 'is-loading': isDeleting }"
									:disabled="selectedItems.length === 0"
									v-tooltip="disabledTooltip"
									@click="isShowDeleteBulk = true"
								>
									<i class="material-icons">delete</i>
									<span>Delete</span>
								</button>
								<!-- Selected Label -->
								<div
									class="btn btn-plain btn-sm disabled"
									v-if="selectedItems.length > 0"
								>
									<span
										><b>{{ selectedItems.length }}</b> Selected Supplier</span
									><span v-if="selectedItems.length > 1">s</span>
								</div>
								<router-link class="btn btn-sm btn-primary" to="/admin/supplier-report">
									Supplier Report
								</router-link>
							</div>
						</div>
						<div class="col-sm-6">
							<div class="table-filters d-flex align-items-center ml-a">
								<!-- Export -->
								<div class="dropdown export ml-auto">
									<button
										type="button"
										class="btn btn-light btn-sm dropdown-toggle flex-center"
										data-toggle="dropdown"
										:class="{ 'is-loading': isExporting }"
									>
										<i class="material-icons">save_alt</i>
										<span class="mr-2">{{ $t('Export') }}</span>
									</button>
									<div class="dropdown-menu">
										<button
											type="button"
											class="dropdown-item"
											:class="{ 'is-loading': isExporting }"
											@click="exportSuppliers('filtered')">
											{{ $t('Export Filtered') }}
										</button>
										<button
											type="button"
											class="dropdown-item"
											:class="{ 'is-loading': isExporting }"
											@click="exportSuppliers('all')">
											{{ $t('Export All') }}
										</button>
									</div>
								</div>
								<!-- Clear Filter -->
								<button
									type="button"
									class="btn btn-plain btn-sm"
									@click="clearFilter"
									v-if="isFilterOn"
								>
									{{ $t('Clear Filter') }}
								</button>
								<!-- Filter -->
								<button type="button" class="filter-toggle btn btn-light btn-sm btn-icon" @click="isShowFilter = true">
									<i class="material-icons mr-1">filter_list</i>Filter Supplier
								</button>
								<!-- Search Keyword -->
								<input
									type="text"
									class="input form-control form-control-sm users-search-box"
									placeholder="Search Users.."
									autocomplete="off"
									@input="onKeywordChange"
									v-model="keyword"
								/>
							</div>
						</div>
					</div>
				</div>
				<!-- Users List -->
				<div class="users-list">
					<table class="users-list-table table table-primary table-striped">
						<thead>
							<tr>
								<th width="5%">
									<label class="input-checkbox-container">
										<input
											type="checkbox"
											class="input-checkbox"
											v-model="selectAll"
										/>
										<span></span>
									</label>
								</th>
								<th
									width="10%"
									class="th-sort text-left"
									:class="sortClass('name')"
									@click="changeSorting('name')"
								>
									Name
								</th>
								<th
									width="10%"
									class="th-sort text-left"
									:class="sortClass('supplier_code')"
									@click="changeSorting('supplier_code')"
								>
									Code
								</th>
								<th
									width="10%"
									class="th-sort text-left"
									:class="sortClass('bussiness-name')"
									@click="changeSorting('store.name')"
								>
									Business Name
								</th>
								<th
									width="10%"
									class="th-sort text-left"
									:class="sortClass('email')"
									@click="changeSorting('email')"
								>
									Email
								</th>
								<!-- <th
									width="6%"
									class="th-sort text-left"
									:class="sortClass('username')"
									@click="changeSorting('username')"
								>
									Username
								</th> -->
								<th
									width="10%"
									class="th-sort text-left"
									:class="sortClass('phone')"
									@click="changeSorting('phone')"
								>
									Phone
								</th>
								<th
									width="5%"
									class="th-sort text-left"
									:class="sortClass('is_phone_verified')"
									@click="changeSorting('is_phone_verified')"
								>
									Phone Verification
								</th>
								<!-- <th
									width="10%"
									class="th-sort text-left"
									:class="sortClass('role')"
									@click="changeSorting('role')"
								>
									Role
								</th> -->
								<th
									width="5%"
									class="th-sort text-left"
									:class="sortClass('is_active')"
									@click="changeSorting('is_active')"
								>
									Status
								</th>
								<th
									width="5%"
									class="th-sort text-left"
									:class="sortClass('store_availability')"
									@click="changeSorting('store_availability')"
								>
									Store Status
								</th>
								<th
									width="5%"
									class="th-sort text-left"
									:class="sortClass('product_availability')"
									@click="changeSorting('product_availability')"
								>
									Product Status
								</th>
								<th
									width="10%"
									class="th-sort text-center"
									:class="sortClass('is_active')"
									@click="changeSorting('is_active')"
								>
									Verification
								</th>
								<!-- <th
									width="5%"
									class="th-sort text-left"
									:class="sortClass('package')"
									@click="changeSorting('package')"
								>
									Package
								</th> -->
								<th
									width="10%"
									class="th-sort text-left"
									:class="sortClass('city')"
									@click="changeSorting('city')"
								>
									City
								</th>
								<th
									width="10%"
									class="th-sort text-left"
									:class="sortClass('created_at')"
									@click="changeSorting('created_at')"
								>
									Join Date
								</th>
								<th width="10%" class="">
									{{ $t('Private Order Feature') }}
								</th>
								<th
									width="10%"
									class="th-sort text-left"
								>
									Actions
								</th>
								<!-- <th
									width="10%"
									class="th-sort text-left"
									:class="sortClass('expired_date')"
									@click="changeSorting('expired_date')"
								>
									Exp. Date
								</th> -->
								<!-- <th
								width="7%"
								class="th-sort text-left"
								:class="sortClass('gross_revenue')"
								@click="changeSorting('gross_revenue')"
								v-if="isAdmin">
								Revenue
							</th>
							<th
								width="7%"
								class="th-sort text-left"
								:class="sortClass('shipping_revenue')"
								@click="changeSorting('shipping_revenue')"
								v-if="isAdmin">
								Shipping Revenue
							</th> -->
							</tr>
						</thead>
						<tbody>
							<tr v-for="item in items" :key="item._id">
								<td class="align-middle">
									<label class="input-checkbox-container">
										<input
											type="checkbox"
											class="input-checkbox"
											:value="item._id"
											v-model="selectedItems"
										/>
										<span></span>
									</label>
								</td>
								<td>
									<div
										class="user__name d-flex text-bold flex-column"
									>
										<div
											class="user__image"
											:style="{ backgroundImage: `url(${item.picture})` }"
											v-if="item.picture"
										></div>
										<span class="text-primary cursor-pointer" @click="openSupplierProfile(item)">{{ item.name }}</span>
										<!-- <div class="row-actions hidden-sm">
											<a href="#" @click.stop.prevent="openUserDetails(item)" class="d-flex align-items-center">
												<i class="material-icons mr-2">groups</i><span>{{ $t('menu.members') }}</span>
											</a>
										</div> -->
									</div>
								</td>
								<td>
									<div class="user__code">{{ item.supplier_code || '-' }}</div>
								</td>
								<td>
									<div class="user__businessname">{{ item.store.name || '-' }}</div>
								</td>
								<td>
									<div class="user__email d-flex align-items-center">
										<a :href="`mailto:${item.email}`" target="_blank">{{
											item.email
										}}</a>
										<!-- <i
											class="material-icons md-18 ml-2 cur-p text-primary"
											v-tooltip="'Edit Email'"
											@click="editUserEmail(item)"
											>edit</i
										> -->
									</div>
									<div class="d-flex align-items-center mt-1">
										<div
											class="user__id"
											v-tooltip="'User ID'">
											{{ item._id }}
										</div>
										<span class="cursor-pointer text-primary ml-1" v-tooltip="'Copy User ID'" @click="copyUserId(item)">
											<i class="bi bi-clipboard"></i>
										</span>
									</div>
								</td>
								<!-- <td>
									<div class="user__username">{{ item.username }}</div>
								</td> -->
								<td>
									<div class="user__phone">{{ item.phone }}</div>
									<div class="d-flex">
										<button
											type="button"
											class="submission-action active submission-action-chat mr-1"
											v-tooltip="$t('Follow-Up 1')"
											@click="followUp(item, 0)"
											>
											<i class="material-icons md-18">phone</i>
										</button>
										<button
											type="button"
											class="submission-action active submission-action-chat mr-1"
											v-tooltip="$t('Follow-Up 2')"
											@click="followUp(item, 1)">
											<i class="material-icons md-18">phone</i>
										</button>
									</div>
								</td>
								<td>
									<div
										class="user__phone_verification"
									>
										<div class="status-pill success" v-if="item.is_phone_verified">
											Verified
										</div>
										<div class="status-pill" v-else>
											Not Verified
										</div>
									</div>
								</td>
								<!-- <td>
									<div class="user__role">{{ item.owner_type }}</div>
								</td> -->
								<td>
									<div class="user__status">
										<div v-if="item.is_suspended" class="status-pill">
											Suspended
										</div>
										<div v-else>
											<div class="status-pill success" v-if="item.is_active">
												Active
											</div>
											<div class="status-pill" v-if="!item.is_active">
												Inactive
											</div>
										</div>
									</div>
								</td>
								<td>
									<div class="user__store_status">
										<div v-if="typeof item.store_availability === 'undefined' || item.store_availability" class="status-pill success">
											Open
										</div>
										<div v-else class="status-pill danger">
											Closed
										</div>
									</div>
								</td>
								<td>
									<div class="user__product_status">
										<div v-if="typeof item.product_availability === 'undefined' || item.product_availability" class="status-pill success">
											Active
										</div>
										<div v-else class="status-pill">
											Suspended
										</div>
									</div>
								</td>
								<td class="text-center">
									<div v-html="getIdentityDisplayStatus(item)" />
								</td>
								<!-- <td>
									<div class="user__package">{{ item.package }}</div>
								</td> -->
								<td>
									<div
										class="user__city"
									>
										{{ getStoreCity(item) }}
									</div>
								</td>
								<td>
									<div
										class="user__date"
										:title="formatDateWithTime(item.created_at)"
									>
										{{ formatDate(item.created_at) }}
									</div>
								</td>
								<td class="text-center">
									<PrivateOrderColumn :item="item" />
								</td>
								<!-- <td>
									<div
										class="user__date"
										:title="formatDateWithTime(item.expired_date)"
									>
										{{ formatDate(item.expired_date) }}
									</div>
								</td> -->
								<td>
									<div class="btn-group">
										<button class="btn btn-default btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
											{{ $t('Action') }}
										</button>
										<div class="dropdown-menu">
											<button
												class="dropdown-item"
												@click="changeSingleUserStatus(item)"
											>
												Change Status
											</button>
											<button
												class="dropdown-item"
												@click="changeSingleUserPassword(item)"
											>
												Change Password
											</button>
											<button
												class="dropdown-item"
												:class="{ 'disabled': selectedItems.length > 1 }"
												@click="updateSingleUserFeatures(item)"
											>
												Update Features
											</button>
											<button
												type="button"
												class="dropdown-item"
												@click="editUserEmail(item)"
											>{{ $t('Change Email') }}</button>
											<button
												type="button"
												class="dropdown-item"
												@click="verifUser(item)"
												:disabled="!isVerificationEnabled(item)"
											>{{ $t('Verification') }}</button>
											<button v-if="!item.is_suspended"
												:disabled="item.product_availability === false"
												type="button"
												class="dropdown-item"
												@click="suspendStatus(item, true)"
											>{{ $t('Suspend') }} {{ item.product_availability === false ? '(Activate Products first)' : '' }}</button>
											<button v-if="item.is_suspended"
												type="button"
												class="dropdown-item"
												@click="suspendStatus(item, false)"
											>{{ $t('Un-Suspend') }}</button>
											<button v-if="typeof item.store_availability === 'undefined' || item.store_availability"
												type="button"
												class="dropdown-item"
												@click="toggleStoreStatusModal(item, true, 'close')"
											>{{ $t('Close Store') }}</button>
											<button v-else
												type="button"
												class="dropdown-item"
												@click="toggleStoreStatusModal(item, true, 'open')"
											>{{ $t('Open Store') }}</button>
											<button
												v-if="typeof item.product_availability === 'undefined' || item.product_availability"
												:disabled="item.is_suspended"
												type="button"
												class="dropdown-item"
												@click="toggleProductStatusModal(item, true, 'suspend')"
											>
												{{ $t('Suspend Products') }} {{ item.is_suspended ? '(Un-Suspend first)' : '' }}
											</button>
											<button
												v-else
												type="button"
												class="dropdown-item"
												@click="toggleProductStatusModal(item, true, 'active')"
											>
												{{ $t('Activate Products') }}
											</button>
										</div>
									</div>
								</td>
								<!-- <td v-if="isAdmin">
								<div
									class="user__date"
									:title="item.gross_revenue">
									{{ formatMoney(item.gross_revenue) }}
								</div>
							</td>
							<td v-if="isAdmin">
								<div
									class="user__date"
									:title="item.shipping_revenue">
									{{ item.shipping_revenue ? formatMoney(item.shipping_revenue) : 0 }}
								</div>
							</td> -->
							</tr>
						</tbody>
					</table>
					<div class="table-fetch-status" v-if="isFetching">
						<div class="is-loading large dark m-auto"></div>
					</div>
					<!-- Empty -->
					<div
						class="list-empty"
						v-if="items.length === 0 && isFetching === false"
					>
						<i class="material-icons mr-2">error_outline</i>
						<span v-if="keyword === ''">There is no users yet.</span>
						<span v-else>No users was found</span>
					</div>
				</div>
			</div>
		</div>
		<!-- Modals -->
		<div class="modals">
			<!-- Update Features -->
			<update-user-feature
				type="supplier"
				:isShow="isShowUpdateFeatures"
				:user="userDetail"
				@updateUser="updateUser"
				@close="closeModalUpdateFeatures"
			/>

			<!-- Modal Filter -->
			<modal
				class="table-filter-modal"
				size="medium"
				@close="isShowFilter = false"
				v-if="isShowFilter">
				<div slot="header">
					<h3><i class="material-icons">filter_list</i>Filter Suppliers</h3>
				</div>
				<div slot="body">
					<!-- status -->
					<div class="form-group">
						<label for="">
							<b class="">
								Status Account
							</b>
						</label>
						<select class="form-control" v-model="is_active">
							<option value="all">All</option>
							<option value="true">Active</option>
							<option value="false">Non Active</option>
						</select>
					</div>
					<!-- identity_status -->
					<div class="form-group">
						<label for="">
							<b class="">
								Status Verification
							</b>
						</label>
						<select class="form-control" v-model="identity_status">
							<option value="all">All</option>
							<option value="requested">Requested</option>
							<option value="skipped">Skipped</option>
							<option value="rejected">Rejected</option>
							<option value="approved">Approved</option>
						</select>
					</div>
				</div>
				<div slot="footer">
					<button type="button" class="btn btn-light" @click="isShowFilter = false">{{ $t('Close') }}</button>
					<button type="button" class="btn btn-primary" @click="applyFilter">Apply</button>
				</div>
			</modal>

			<!-- Bulk Delete Confirm -->
			<modal
				class="coupon-editor-modal"
				size="medium"
				v-if="isShowDeleteBulk"
				@close="isShowDeleteBulk = false"
			>
				<div slot="header">
					<h3><i class="material-icons">delete</i>Delete User</h3>
				</div>
				<div slot="body">
					Are you sure want to delete {{ selectedItems.length }} users?
				</div>
				<div slot="footer">
					<button
						type="button"
						class="btn btn-light"
						@click="isShowDeleteBulk = false"
					>
						{{ $t('Close') }}
					</button>
					<button type="button" class="btn btn-danger" @click="bulkDelete">
						Delete
					</button>
				</div>
			</modal>

			<!-- Delete Confirm -->
			<modal
				class="coupon-editor-modal"
				size="medium"
				v-if="isShowDelete"
				@close="isShowDelete = false"
			>
				<div slot="header">
					<h3><i class="material-icons">delete</i>Delete User</h3>
				</div>
				<div slot="body">
					Are you sure want to delete {{ selectedItem.name }}?
				</div>
				<div slot="footer">
					<button
						type="button"
						class="btn btn-light"
						@click="isShowDelete = false"
					>
						{{ $t('Close') }}
					</button>
					<button type="button" class="btn btn-danger" @click="deleteProduct">
						Delete
					</button>
				</div>
			</modal>

			<!-- Add New Supplier -->
			<modal
				class="supplier-create-modal"
				size="large"
				v-if="isShowCreateItem"
				@close="isShowCreateItem = false"
			>
				<div slot="header">
					<h3><i class="material-icons">add</i>Create Supplier</h3>
				</div>
				<div slot="body">
					<div class="container-fluid">
						<div class="row">
							<div class="col-md-6">
								<div class="form-group">
									<label><b>Name</b></label>
									<input
										v-focus
										type="text"
										name="name"
										class="input form-control"
										placeholder="Name"
										autocomplete="off"
										v-model="userData.name"
									/>
								</div>
								<!-- <div class="form-group">
									<label><b>Username</b></label>
									<input
										type="text"
										name="username"
										class="input form-control"
										placeholder="Username"
										autocomplete="off"
										v-model="userData.username"
									/>
								</div> -->
								<div class="form-group">
									<label><b>Email</b></label>
									<input
										type="email"
										name="email"
										class="input form-control"
										placeholder="Email"
										autocomplete="off"
										v-model="userData.email"
									/>
								</div>
								<div class="form-group">
									<label><b>Password</b></label>
									<input
										type="password"
										name="password"
										class="input form-control"
										placeholder="Password"
										autocomplete="off"
										v-model="userData.password"
									/>
								</div>

								<div class="form-group">
									<label><b>Phone</b></label>
									<input
										type="tel"
										name="phone"
										class="input form-control"
										placeholder="+628xxx"
										autocomplete="off"
										v-model="userData.phone"
									/>
								</div>
								<!-- <div class="form-group">
									<label><b>Package</b></label>
									<multiselect
										placeholder="Select Package.."
										:options="packages"
										:taggable="false"
										:show-labels="false"
										:show-no-results="true"
										:label="'label'"
										:track-by="'name'"
										:preselect-first="true"
										:allow-empty="false"
										v-model="selectedPackage"
										@select="onSelectPackage"
									>
										<span slot="noResult">No Package found.</span>
									</multiselect>
								</div> -->
								<div class="form-group">
									<label><b>Expired In</b></label>
									<select class="form-control" v-model="userData.expired_at">
										<option
											v-for="(packageLength, index) in packagesLength"
											:key="index"
											:value="packageLength.value"
										>
											{{ packageLength.label }}
										</option>
									</select>
								</div>
								<div class="form-group hidden">
									<label><b>Role</b></label>
									<select class="form-control" v-model="userData.owner_type">
										<option value="supplier">Supplier</option>
										<option value="dropshipper">Seller</option>
									</select>
								</div>
							</div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Business Name</label>
                                    <input type="text" name="businessName" class="form-control" placeholder="Business Name" v-model="businessName" required>
                                </div>
                                <div class="form-group">
                                    <label>Businnes Address</label>
                                    <textarea name="businessAddress" class="form-control" rows="3" placeholder="Business Address" v-model="businessAddress" required></textarea>
                                </div>
                            </div>
						</div>
					</div>
				</div>
				<div slot="footer">
					<button
						type="button"
						class="btn btn-light"
						@click="isShowCreateItem = false"
					>
						Cancel
					</button>
					<button
						type="button"
						class="btn btn-primary"
						:class="{ 'is-loading': isCreating }"
						@click="createUser"
					>
						Create Supplier
					</button>
				</div>
			</modal>

			<!-- Change Package -->
			<modal
				size="small"
				v-if="isShowChangePackage"
				@close="isShowChangePackage = false"
			>
				<div slot="header"><h3>Change Package</h3></div>
				<div slot="body">
					<div class="form-group">
						<label><b>Package</b></label>
						<multiselect
							placeholder="Select Package.."
							:options="packages"
							:taggable="false"
							:show-labels="false"
							:show-no-results="true"
							:label="'name'"
							:track-by="'name'"
							:preselect-first="true"
							:allow-empty="false"
							v-model="selectedPackage"
						>
							<span slot="noResult">No Package found.</span>
						</multiselect>
					</div>
				</div>
				<div slot="footer">
					<button
						type="button"
						class="btn btn-light"
						@click="isShowChangePackage = false"
					>
						Cancel
					</button>
					<button
						type="button"
						class="btn btn-primary"
						:class="{ 'is-loading': isUpdatingPackage }"
						@click="updatePackage"
					>
						Update Package
					</button>
				</div>
			</modal>

			<!-- Change Expiration Date -->
			<modal
				size="small"
				v-if="isShowChangeExpiration"
				@close="isShowChangeExpiration = false"
			>
				<div slot="header"><h3>Change Expired Date</h3></div>
				<div slot="body">
					<div class="form-group">
						<label><b>Expired Date</b></label>
						<input
							type="date"
							name="expiration_date"
							class="form-control"
							v-model="expirationDate"
						/>
					</div>
				</div>
				<div slot="footer">
					<button
						type="button"
						class="btn btn-light"
						@click="isShowChangeExpiration = false"
					>
						Cancel
					</button>
					<button
						type="button"
						class="btn btn-primary"
						:class="{ 'is-loading': isUpdatingExpiration }"
						@click="updateExpiration"
					>
						Update Expiration
					</button>
				</div>
			</modal>

			<!-- Change Status -->
			<modal
				size="small"
				v-if="isShowChangeStatus"
				@close="isShowChangeStatus = false"
			>
				<div slot="header"><h3>Change Status</h3></div>
				<div slot="body">
					<div class="form-group">
						<label><b>Status</b></label>
						<select class="form-control" v-model="selectedStatus">
							<option :value="1">Active</option>
							<option :value="0">Inactive</option>
						</select>
					</div>
				</div>
				<div slot="footer">
					<button
						type="button"
						class="btn btn-light"
						@click="isShowChangeStatus = false"
					>
						Cancel
					</button>
					<button
						type="button"
						class="btn btn-primary"
						:class="{ 'is-loading': isUpdatingStatus }"
						@click="updateStatus"
					>
						Update Status
					</button>
				</div>
			</modal>

			<!-- Change Password -->
			<modal
				size="small"
				v-if="isShowChangePassword"
				@close="isShowChangePassword = false"
			>
				<div slot="header"><h3>Change Password</h3></div>
				<div slot="body">
					<div class="form-group">
						<label><b>Password</b></label>
						<input
							type="password"
							name="new_password"
							class="form-control"
							placeholder="New Password"
							v-model="selectedPassword"
						/>
					</div>
				</div>
				<div slot="footer">
					<button
						type="button"
						class="btn btn-light"
						@click="isShowChangePassword = false"
					>
						Cancel
					</button>
					<button
						type="button"
						class="btn btn-primary"
						:class="{ 'is-loading': isUpdatingPassword }"
						@click="updatePassword"
					>
						Update Password
					</button>
				</div>
			</modal>

			<!-- Change Email -->
			<modal
				size="small"
				@close="isEditEmailVisible = false"
				v-if="isEditEmailVisible"
			>
				<div slot="header">
					<h3>Change Email</h3>
				</div>
				<div slot="body">
					<div class="form-group">
						<label><b>Email</b></label>
						<input
							type="text"
							name="new_email"
							class="form-control"
							placeholder="New Email"
							v-model="userNewEmail"
						/>
					</div>
				</div>
				<div slot="footer">
					<button
						type="button"
						class="btn btn-light"
						@click="isEditEmailVisible = false"
					>
						Cancel
					</button>
					<button
						type="button"
						class="btn btn-primary"
						:class="{ 'is-loading': isUpdatingEmail }"
						@click="updateEmail"
					>
						Update Email
					</button>
				</div>
			</modal>

			<!-- Details -->
			<user-details
				:user="userDetail"
				v-if="isDetailsVisible && !!userDetail"
				@close="isDetailsVisible = false"
			/>

			<!-- Selected Users -->
			<!-- <modal
				@close="isSelectedListVisible = false"
				v-if="isSelectedListVisible">
				<template slot="header">
					<h3>Selected Users</h3>
				</template>
				<template slot="body">
					{{ selectedItems }}
				</template>
				<template slot="footer">
					<button
						type="button"
						class="btn btn-primary"
						@click="isSelectedListVisible = false">
						OK
					</button>
				</template>
			</modal> -->

			<!-- modal show team member -->
			<!-- Change Status -->
			<modal
				size="large"
				v-if="isShowTeamMember"
				@close="isShowTeamMember = false"
			>
				<div slot="header">
					<h3>{{ $t('menu.members') }}</h3>
				</div>
				<div slot="body">
					<div class="">
						<!-- Main Table -->
						<div class="table-responsive">
							<table class="table table-striped table--small">
								<thead>
									<tr>
										<th width="3%" class="th-sort">No</th>
										<th width="5%" class="align-middle p-0"></th>
										<th class="text-left th-sort">Name</th>
										<th class="text-left th-sort hidden-sm">Email</th>
										<th class="text-left hidden-sm">Phone</th>
										<th class="text-left th-sort hidden-sm">Role</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(member, index) in teamMembers" :key="member._id">
										<td>{{ index + 1 }}.</td>
										<td class="align-middle text-center pt-0 pb-0">
											<div class="member-picture">
												<img
													:src="member.picture"
													:alt="member.name"
													v-if="member.picture"
												/>
												<i class="material-icons" v-if="!member.picture"
													>account_box</i
												>
											</div>
										</td>
										<td>
											<div class="member-name">{{ member.name }}</div>
										</td>
										<td>
											<div class="member-email">{{ member.email }}</div>
										</td>
										<td>
											<div class="member-phone" v-if="member.phone">
												{{ member.phone }}
											</div>
										</td>
										<td>
											<div class="member-role">{{ member.role }}</div>
										</td>
										<!-- <td>
										<div class="member-date">{{ moment(member.created_at).format('DD-MM-YYYY') }}</div>
									</td> -->
									</tr>
								</tbody>
							</table>
						</div>

						<!-- Table Loader -->
						<div class="table-fetch-status" v-if="isFetchingMember">
							<div class="is-loading large dark m-auto"></div>
						</div>

						<!-- Table Empty -->
						<div
							class="list-empty"
							v-if="teamMembers.length === 0 && isFetchingMember === false"
						>
							<i class="material-icons md-48 mr-2">error_outline</i>
							<span>No member was found</span>
						</div>
					</div>
				</div>
				<div slot="footer">
					<button
						type="button"
						class="btn btn-light"
						@click="isShowTeamMember = false"
					>
						Closed
					</button>
				</div>
			</modal>

			<!-- Follow Up -->
			<follow-up-modal
				:name="followUpName"
				:number="followUpNumber"
				:message="followUpMessage"
				@close="hideFollowUp"
				v-if="isFollowUpVisible"
			/>

			<!-- Modal User Verification -->
			<modal-user-verification
				:user="selectedItem"
				:source="verificationModalSource"
				@close="closeModalVerification"
				@update="updateUserIdentity"
				@back-supplier="openSupplierProfileFromVerification"
				v-if="isModalVerificationVisible"
			/>

			<!-- Modal Supplier Profile -->
			<modal-supplier-profile
				:user="selectedItem"
				@close="closeSupplierProfile"
				@verification="openVerificationFromSupplierProfile"
				v-if="isModalSupplierProfileVisible"
			/>
			<!-- Modal Supplier Suspend -->
			<modal
				class="table-filter-modal"
				size="medium"
				@close="isModalSuspendVisible = false"
				v-if="isModalSuspendVisible">
				<div slot="header">
					<h3>{{modalSuspendData.title}}</h3>
				</div>
				<div slot="body">
					<div class="text-center">
						{{ modalSuspendData.description }}
					</div>
				</div>
				<div slot="footer">
					<button type="button" class="btn btn-light" @click="isModalSuspendVisible = false">{{ $t('Close') }}</button>
					<button type="button" class="btn btn-primary" :class="{ 'is-loading': isLoadingSuspend }" @click="doSuspend" :disabled="isLoadingSuspend">Submit</button>
				</div>
			</modal>

			<!-- Modal Store Status -->
			<modal-update-store-status
				v-if="isStoreStatusModalVisible"
				:store-status-state="storeStatusState"
				:is-bulk-update-store-status="isBulkUpdateStoreStatus"
				:is-updating-store-status="isUpdatingStoreStatus"
				:selected-items="selectedItems"
				:selected-item="selectedItem"
				@close="toggleStoreStatusModal(null, false)"
				@update="updateStoreStatus"
			/>

			<!-- Modal Product Status -->
			<modal-update-product-status
				v-if="isProductStatusModalVisible"
				:product-status-state="productStatusState"
				:is-bulk-update-product-status="isBulkUpdateProductStatus"
				:is-updating-product-status="isUpdatingProductStatus"
				:selected-items="selectedItems"
				:selected-item="selectedItem"
				@close="toggleProductStatusModal(null, false)"
				@update="updateProductStatus"
			/>
		</div>

		<!-- Notifications -->
		<notifications group="suppliers" position="bottom right" />
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import dayjs from 'dayjs';
import Modal from '@/components/Modal.vue';
import Daterangepicker from '@/components/Daterangepicker.vue';
import UserDetails from '@/components/UserDetails.vue';
import FollowUpModal from '@/components/FollowUpModal.vue';
import ModalUserVerification from '@/components/ModalUserVerification.vue';
import ModalSupplierProfile from '@/components/ModalSupplierProfile.vue';
import ModalUpdateStoreStatus from '@/components/ModalUpdateStoreStatus.vue';
import ModalUpdateProductStatus from '@/components/ModalUpdateProductStatus.vue';
import updateUserFeature from '@/components/UpdateUserFeature.vue';
import PrivateOrderColumn from '@/components/PrivateOrderColumn.vue';
import {
	defaultPackages,
	defaultPackagesLength,
	defaultUserData,
	defaultFollowUpMessage,
} from '@/lib/statics';
import {
	duplicateVar,
	formatMoney,
	getDateRange,
	getAxiosErrorMessage,
	formatWaNumber,
	slugify,
	downloadFile,
	sanitizeHtml,
	copyToClipboard,
} from '@/lib/helper';
import usersApi from '@/api/user';
import adminApi, { bulkUpdateStoreStatus } from '@/api/admin';
import userPackageApi from '@/api/userPackage';
import settingApi from '@/api/setting';

const teams = [
	{
		_id: '5ea63cfe84d07351ea38d45b',
		name: 'CS 4',
		email: 'cs4.orderonline@gmail.com',
		phone: '+62121212121212121',
		picture: '',
		is_active: true,
		on_duty: false,
		role: 'cs',
		created_at: '2020-04-27 02:01:34',
	},
	{
		_id: '5ce240959f05aa74144754f7',
		name: 'Irfan',
		email: 'old-ordivo.id@gmail.com',
		phone: '+8285255255255',
		picture: '',
		is_active: true,
		role: 'cs',
		created_at: '2019-05-20 05:52:21',
		on_duty: true,
	},
	{
		_id: '5c6103ac9f05aa58b7258962',
		name: 'Putra',
		email: 'thejampang78@gmail.com',
		phone: '+6285255255112',
		picture: '',
		is_active: true,
		role: 'cs',
		created_at: '2019-02-11 05:10:04',
		on_duty: true,
	},
	{
		_id: '5b7b7d789f05aa11cd658982',
		name: 'Maul',
		email: 'csbarus@gmail.com',
		phone: '+6283100223332',
		picture: '',
		is_active: true,
		role: 'cs',
		created_at: '2018-08-21 02:48:24',
		on_duty: true,
	},
	{
		_id: '5b71d2809f05aa32070e19e2',
		name: 'Ekhy',
		email: 'shipper@gmail.com',
		phone: '',
		picture: '',
		is_active: true,
		role: 'shipper',
		created_at: '2018-08-13 18:48:32',
		on_duty: true,
	},
	{
		_id: '5b6e91d99f05aa59c12dfd54',
		name: 'Rofy Korda',
		email: 'rofy@gmail.com',
		picture: '',
		is_active: true,
		role: 'admin',
		created_at: '2018-08-11 07:35:53',
		phone: '+62808080',
		on_duty: true,
	},
	{
		_id: '5b6e8f5b9f05aa57a003b962',
		name: 'Jaya',
		email: 'rovan_63@yahoo.co.id',
		picture: 'https://images.orderonline.id/8537051534144883911.png',
		is_active: true,
		role: 'cs',
		created_at: '2018-08-11 07:25:15',
		phone: '+6285862749672',
		on_duty: true,
	},
];

export default {
	name: 'userManagement',
	components: {
		Modal,
		Daterangepicker,
		UserDetails,
		FollowUpModal,
		ModalUserVerification,
		ModalSupplierProfile,
		ModalUpdateStoreStatus,
		ModalUpdateProductStatus,
		updateUserFeature,
		PrivateOrderColumn,
	},
	data() {
		return {
			userData: duplicateVar(defaultUserData),
			items: [],
			selectedItems: [],
			selectedItem: null,
			keyword: '',
			limit: 20,
			sort_by: 'created_at',
			sort: 'asc',
			isAll: false,
			isFetching: false,
			isCreating: false,
			isDeleting: false,
			isShowDelete: false,
			isShowDeleteBulk: false,
			isShowCreateItem: false,
			isShowChangePackage: false,
			isShowChangeStatus: false,
			isShowChangePassword: false,
			isShowChangeExpiration: false,
			isUpdatingPackage: false,
			isUpdatingStatus: false,
			isUpdatingPassword: false,
			isUpdatingExpiration: false,
			isEditEmailVisible: false,
			packages: duplicateVar(defaultPackages),
			packagesLength: defaultPackagesLength,
			selectedPackage: null,
			selectedPackageLength: null,
			selectedStatus: 1,
			selectedPassword: null,
			expirationDate: '1992-12-24',
			since: null,
			until: null,
			userNewEmail: '',
			isUpdatingEmail: false,
			userDetail: null,
			isDetailsVisible: false,
			isShowTeamMember: false,
			isFetchingMember: false,
			teamMembers: teams,
			isShowFilter: false,
			isShowUpdateFeatures: false,
			identity_status: 'all',
			is_active: 'all',
			owner_type: 'supplier',
			followUpNumber: '',
			followUpName: '',
			followUpMessage: '',
			followUpMessages: '',
			isFollowUpVisible: false,
			isModalVerificationVisible: false,
			isModalSupplierProfileVisible: false,
			verificationModalSource: 'direct',
			businessName: '',
			businessAddress: '',
			isExporting: false,
			isModalSuspendVisible: false,
			isLoadingSuspend: false,
			modalSuspendData: {
				title: '',
				description: '',
				status: '',
			},
			isStoreStatusModalVisible: false,
			isUpdatingStoreStatus: false,
			isBulkUpdateStoreStatus: false,
			storeStatusState: 'open',
			productStatusState: 'active',
			isProductStatusModalVisible: false,
			isUpdatingProductStatus: false,
			isBulkUpdateProductStatus: false,
		};
	},
	methods: {
		...mapActions({}),
		resetItems() {
			this.items = [];
			this.selectedItems = [];
			this.isAll = false;
			this.page = 1;
		},
		doSuspend() {
			this.isLoadingSuspend = true;
			const userId = this.selectedItem._id;
			const suspendStatus = this.modalSuspendData.status !== 'request';
			const callback = (response) => {
				const user = this.selectedItem;
				if (user) {
					user.is_suspended = suspendStatus;
				}
				const message = response.message;
				this.$notify({
					group: 'app',
					title: 'Suspended status updated',
					text: message,
					type: 'success',
				});
				this.isLoadingSuspend = false;
				this.isModalSuspendVisible = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					title: 'Failed to update Status',
					text: message,
					type: 'danger',
				});
				this.isLoadingSuspend = false;
			};

			const params = {
				user_id: userId,
				status: this.modalSuspendData.status,
			};
			usersApi.suspendStatus(params, callback, errorCallback);
		},
		suspendStatus(user, status) {
			if (status === true) {
				this.modalSuspendData.title = 'Confirm Suspend';
				this.modalSuspendData.description = 'Are you sure want to Suspend this user ?';
				this.modalSuspendData.status = 'suspended';
			} else {
				this.modalSuspendData.title = 'Confirm Un-Suspend';
				this.modalSuspendData.description = 'Are you sure want to Un-Suspend this user ?';
				this.modalSuspendData.status = 'request';
			}
			this.selectedItem = user;
			this.isModalSuspendVisible = true;
		},
		getFetchParams() {
			const params = {
				limit: this.limit,
				sort_by: this.sort_by,
				sort: this.sort,
				page: this.page,
				since: this.since,
				until: this.until,
			};

			if (this.owner_type !== 'all') {
				params.owner_type = this.owner_type;
			}

			if (this.identity_status !== 'all') {
				params.identity_status = this.identity_status;
			}

			if (this.is_active !== 'all') {
				params.is_active = this.is_active;
			}

			if (this.userId) {
				params.user_id = this.userId;
			}

			const keyword = this.keyword.trim();
			if (keyword !== '') {
				params.keyword = keyword;
			}

			return params;
		},
		fetchItems(reset = true) {
			this.isFetching = true;
			if (reset) {
				this.resetItems();
			}

			const params = this.getFetchParams();

			const callback = (response) => {
				this.isFetching = false;
				const users = response.data;
				if (users.length > 0) {
					this.page++;
					this.items = this.items.concat(users);
				} else {
					this.isAll = true;
				}
			};

			const errorCallback = () => {
				this.isFetching = false;
			};

			if (this.isAdmin) {
				usersApi.getUsers(params, callback, errorCallback);
			} else if (this.isSupport) {
				usersApi.getUsersMinimal(params, callback, errorCallback);
			}
		},
		onKeywordChange() {
			// const self = this;
			this.ooDelay(() => {
				if (this.isAdmin) {
					this.fetchItems();
				} else if (this.isSupport) {
					if (this.keyword.trim() === '') {
						this.resetItems();
					} else {
						this.fetchItems();
					}
				}
			}, 1000);
		},
		handleScroll() {
			const pageHeight = document.documentElement.offsetHeight;
			const windowHeight = window.innerHeight;
			const scrollPosition = window.scrollY;
			const offset = 50;
			const isOnBottom = pageHeight - offset <= windowHeight + scrollPosition;
			if (isOnBottom) {
				if (!this.isFetching && !this.isAll) {
					this.fetchItems(false);
				}
			}
		},
		bulkDelete() {
			this.isDeleting = true;
			const userIds = this.selectedItems.slice();
			const callback = () => {
				this.isDeleting = false;
				for (let i = 0; i < this.selectedItems.length; i++) {
					const id = this.selectedItems[i];
					const index = this.items.findIndex(item => item._id === id);
					const isIndex = index !== -1;
					if (isIndex) {
						this.items.splice(index, 1);
					}
				}
				this.$set(this, 'selectedItems', []);

				this.isShowDeleteBulk = false;
				this.$notify({
					group: 'suppliers',
					title: 'Suppliers',
					text: 'Supplier deleted',
					type: 'success',
				});
			};
			const errorCallback = () => {
				this.isDeleting = false;
				this.isShowDeleteBulk = false;
			};
			usersApi.bulkDelete(userIds, callback, errorCallback);
		},
		delete() {
			this.isDeleting = true;
			const callback = () => {
				this.isDeleting = false;
				const id = this.selectedItem._id;
				const index = this.items.findIndex(item => item._id === id);
				const isIndex = index !== -1;
				if (isIndex) {
					this.items.splice(index, 1);
				}
				this.$set(this, 'selectedItem', null);
				this.$notify({
					group: 'suppliers',
					title: 'Suppliers',
					text: 'Supplier deleted',
					type: 'success',
				});
			};
			const errorCallback = () => {
				this.isDeleting = false;
			};
			const userIds = [this.selectedItem._id];
			usersApi.bulkDelete(userIds, callback, errorCallback);
		},
		changeSorting(key) {
			const isSame = this.sort_by === key;
			this.sort_by = key;
			const sort = isSame && this.sort === 'asc' ? 'desc' : 'asc';
			this.sort = sort;
			// Re-fetch
			this.fetchItems(true);
		},
		sortClass(key) {
			const sameKey = this.sort_by === key;
			const className = sameKey ? `th-sort-${this.sort}` : '';
			return className;
		},
		showConfirmDeleteProduct(item) {
			this.selectedItem = item;
			this.isShowDelete = true;
		},
		formatDate(date) {
			return this.moment(date).format('DD-MM-YYYY');
		},
		formatDateWithTime(date) {
			return this.moment(date).format('DD-MM-YYYY HH:mm:ss');
		},
		createUser() {
			this.isCreating = true;
			const params = duplicateVar(this.userData);
			params.owner_type = this.owner_type;
			params.business_name = this.businessName;
			params.business_address = this.businessAddress;
			params.username = slugify(params.email);

			let isEmpty = false;
			Object.values(params).forEach((item) => {
				if (item === '') {
					isEmpty = true;
				}
			});

			if (isEmpty) {
				this.$notify({
					group: 'suppliers',
					title: 'Suppliers',
					text: 'Mohon isi semua form.',
					type: 'error',
				});
			} else {
				const callback = (response) => {
					this.isCreating = false;
					const user = response.data;
					this.items.push(user);

					this.userData = duplicateVar(defaultUserData);
					this.isShowCreateItem = false;

					this.$notify({
						group: 'suppliers',
						title: 'Suppliers',
						text: 'Supplier has been created',
						type: 'success',
					});
				};
				const errorCallback = (e) => {
					this.isCreating = false;
					const message = e.response.message;
					// this.isShowCreateItem = false;
					this.$notify({
						group: 'suppliers',
						title: 'Suppliers',
						text: message,
						type: 'error',
					});
				};
				usersApi.create(params, callback, errorCallback);
			}
		},
		onSelectPackage(plan) {
			this.userData.package = plan.name;
		},
		updatePackage() {
			this.isUpdatingPackage = true;
			const userIds = this.selectedItems.slice();
			const packageName = this.selectedPackage.name;
			const callback = () => {
				this.isUpdatingPackage = false;
				for (let i = 0; i < this.selectedItems.length; i++) {
					const userId = this.selectedItems[i];
					const user = this.items.find(user => user._id === userId);
					if (user) {
						user.package = packageName;
					}
				}
				this.isShowChangePackage = false;
				this.$notify({
					group: 'suppliers',
					title: 'Suppliers',
					text: 'Supplier package has been updated',
					type: 'success',
				});
			};
			const errorCallback = () => {
				this.isUpdatingPackage = false;
				this.isShowChangePackage = false;
			};
			usersApi.bulkChangePackage(userIds, packageName, callback, errorCallback);
		},
		updateStatus() {
			this.isUpdatingStatus = true;
			const userIds = this.selectedItems.slice();
			const status = this.selectedStatus;
			const callback = () => {
				this.isUpdatingStatus = false;
				for (let i = 0; i < this.selectedItems.length; i++) {
					const userId = this.selectedItems[i];
					const user = this.items.find(user => user._id === userId);
					if (user) {
						const isActive = status === 1;
						user.is_active = isActive;
					}
				}
				this.isShowChangeStatus = false;
				this.resetSelectedItems();
				this.$notify({
					group: 'suppliers',
					title: 'Suppliers',
					text: 'Supplier status has been updated',
					type: 'success',
				});
			};
			const errorCallback = () => {
				this.isUpdatingStatus = false;
				this.isShowChangeStatus = false;
			};
			usersApi.bulkChangeStatus(userIds, status, callback, errorCallback);
		},
		updatePassword() {
			this.isUpdatingPassword = true;
			const userIds = this.selectedItems.slice();
			const password = this.selectedPassword;
			const callback = () => {
				this.isUpdatingPassword = false;
				this.isShowChangePassword = false;
				this.selectedPassword = '';
				this.resetSelectedItems();
				this.$notify({
					group: 'suppliers',
					title: 'Suppliers',
					text: 'Supplier password has been updated',
					type: 'success',
				});
			};
			const errorCallback = () => {
				this.isUpdatingPassword = false;
				this.isShowChangePassword = false;
			};
			usersApi.bulkChangePassword(userIds, password, callback, errorCallback);
		},
		updateExpiration() {
			this.isUpdatingExpiration = true;
			const userIds = this.selectedItems.slice();
			const expirationDate = this.expirationDate;
			const callback = () => {
				this.isUpdatingExpiration = false;
				for (let i = 0; i < this.selectedItems.length; i++) {
					const userId = this.selectedItems[i];
					const user = this.items.find(user => user._id === userId);
					if (user) {
						user.expired_date = `${expirationDate} 23:59:59`;
					}
				}
				this.isShowChangeExpiration = false;
				this.$notify({
					group: 'suppliers',
					title: 'Suppliers',
					text: 'Supplier expiration has been updated',
					type: 'success',
				});
			};
			const errorCallback = () => {
				this.isUpdatingExpiration = false;
				this.isShowChangeExpiration = false;
			};
			usersApi.bulkChangeExpiredDate(
				userIds,
				expirationDate,
				callback,
				errorCallback,
			);
		},
		fetchPackages() {
			const callback = (response) => {
				const packages = response.data;
				this.packages = packages;
			};
			const errorCallback = () => {};
			userPackageApi.getPackages(callback, errorCallback);
		},
		formatMoney(str) {
			return formatMoney(str);
		},
		setFilterDate(filterDate) {
			this.filterDate = filterDate;
			const dateFormat = 'YYYY-MM-DD';
			const since = dayjs(filterDate.start).format(dateFormat);
			const until = dayjs(filterDate.end).format(dateFormat);
			this.since = since;
			this.until = until;
			const query = duplicateVar(this.$route.query);
			query.since = since;
			query.until = until;
			const params = { query };
			this.$router.push(params);
			// this.fetchItems(true);
		},
		initFilterDate() {
			const dateRange = getDateRange();
			const hasSinceQuery = this.sinceQuery && this.sinceQuery !== '';
			const hasUntilQuery = this.untilQuery && this.untilQuery !== '';
			const sinceDate = hasSinceQuery
				? dayjs(this.sinceQuery)
				: dayjs(dateRange.start);
			const untilDate = hasUntilQuery
				? dayjs(this.untilQuery)
				: dayjs(dateRange.end);
			const filterDate = {
				start: sinceDate,
				end: untilDate,
			};
			this.filterDate = filterDate;

			const dateFormat = 'YYYY-MM-DD';
			this.since = sinceDate.format(dateFormat);
			this.until = untilDate.format(dateFormat);
		},
		editUserEmail(user) {
			this.selectedItem = duplicateVar(user);
			this.userNewEmail = duplicateVar(user.email);
			this.isEditEmailVisible = true;
		},
		updateEmail() {
			this.isUpdatingEmail = true;
			const userId = this.selectedItem._id;
			const email = this.userNewEmail.trim();
			const params = {
				email,
			};
			const callback = (response) => {
				this.updateEmailInList(userId, email);
				const message = response.message;
				this.$notify({
					group: 'app',
					title: 'User Update Email',
					text: message,
					type: 'success',
				});
				this.isUpdatingEmail = false;
				this.isEditEmailVisible = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					title: 'User Update Email',
					text: message,
					type: 'danger',
				});
				this.isUpdatingEmail = false;
			};
			usersApi.update(userId, params, callback, errorCallback);
		},
		updateEmailInList(userId, email) {
			const index = this.items.findIndex(({ _id }) => _id === userId);
			if (index !== -1) {
				const user = duplicateVar(this.items[index]);
				user.email = email;
				this.$set(this.items, index, user);
			}
		},
		openUserDetails(user) {
			this.userDetail = user;
			this.isDetailsVisible = true;
		},
		showTeamMember(id) {
			console.log('id: ', id);
			this.isDetailsVisible = false;
			this.userDetail = null;
			this.isShowTeamMember = true;
		},
		getIdentityStatus(user) {
			let status = '';
			if (user.identity !== undefined && user.identity.status !== undefined) {
				status = user.identity.status;
			}
			return status;
		},
		getIdentityDisplayStatus(user) {
			let displayStatus = '-';
			switch (this.getIdentityStatus(user)) {
			case 'requested':
				displayStatus = '<div class="status-pill warning">Requested</div>';
				break;
			case 'skipped':
				displayStatus = '<div class="status-pill warning">Skipped</div>';
				break;
			case 'rejected':
				displayStatus = '<div class="status-pill danger">Rejected</div>';
				break;
			case 'approved':
				displayStatus = '<div class="status-pill success">Approved</div>';
				break;
			default:
				break;
			}
			return sanitizeHtml(displayStatus);
		},
		isVerificationEnabled(user) {
			const status = this.getIdentityStatus(user);
			return status === 'requested' || status === 'rejected' || status === 'approved' || status === 'skipped';
		},
		applyFilter() {
			this.fetchItems();
			this.isShowFilter = false;
		},
		followUp(user, type) {
			this.generateFollowUp(user, type);
			this.isFollowUpVisible = true;
		},
		hideFollowUp() {
			this.followUpNumber = '';
			this.followUpName = '';
			this.followUpMessage = '';
			this.isFollowUpVisible = false;
		},
		generateFollowUp(user, type) {
			const phone = user.phone;
			const customerName = user.name || '';
			const followUpMessages = this.followUpMessages !== '' ? this.followUpMessages : defaultFollowUpMessage;
			this.followUpNumber = formatWaNumber(phone);
			this.followUpName = customerName;
			this.followUpMessage = followUpMessages[type].message;
		},
		verifUser(user) {
			this.selectedItem = user;
			this.isModalVerificationVisible = true;
		},
		closeModalVerification() {
			this.verificationModalSource = 'direct';
			this.selectedItem = null;
			this.isModalVerificationVisible = false;
		},
		updateUserIdentity(value) {
			for (let i = 0; i < this.selectedItems.length; i++) {
				const userId = this.selectedItems[i];
				const user = this.items.find(user => user._id === userId);
				if (user) {
					user.identity = value;
				}
			}
		},
		fetchCurrentSetting() {
			this.isFetchingSetting = true;
			const params = this.params;
			const callback = (response) => {
				const settings = response.data;
				this.followUpMessages = settings?.data?.follow_up_text?.supplier ?? defaultFollowUpMessage;
				this.isFetchingSetting = false;
			};
			const errorCallback = (e) => {
				const msg = getAxiosErrorMessage(e);
				// eslint-disable-next-line
				console.log(msg);
			};
			settingApi.getCurrent(params, callback, errorCallback);
		},
		fetchData() {
			if (this.isAdmin) {
				this.fetchItems();
				this.fetchCurrentSetting();
			}
		},
		exportSuppliers(type = 'filtered') {
			this.isExporting = true;
			const params = this.getFetchParams();
			if (type === 'all') {
				delete params.since;
				delete params.until;
			}
			const callback = (response) => {
				this.isExporting = false;
				const url = response.data;
				downloadFile(url);
			};
			const errorCallback = () => {
				this.isExporting = false;
			};

			adminApi.exportSuppliers(params, callback, errorCallback);
		},
		checkParams() {
			if (this.statusParam) {
				this.identity_status = this.statusParam;
			}
		},
		resetFilter() {
			this.identity_status = 'all';
			this.is_active = 'all';
		},
		clearFilter() {
			this.resetFilter();
			this.$router.replace({ query: null });
		},
		fetchSuppliers() {
			this.checkParams();
			this.fetchData();
		},
		openModalUpdateFeatures(userId) {
			if (this.selectedItems.length === 1) {
				const user = this.items.find(x => x._id === userId);
				this.userDetail = user;
				this.isShowUpdateFeatures = true;
			}
		},
		closeModalUpdateFeatures() {
			this.resetSelectedItems();
			this.isShowUpdateFeatures = false;
		},
		updateUser(newFeature) {
			const userId = this?.userDetail?._id;
			const user = this.items.find(user => user._id === userId);
			if (user) {
				const currentFeature = user?.features ?? [];
				if (!currentFeature.includes(newFeature)) {
					user.features = [...currentFeature, newFeature];
				}
			}
		},
		openSupplierProfile(user) {
			this.selectedItem = user;
			this.isModalSupplierProfileVisible = true;
		},
		closeSupplierProfile() {
			this.selectedItem = null;
			this.isModalSupplierProfileVisible = false;
		},
		openVerificationFromSupplierProfile(user) {
			this.closeSupplierProfile();
			this.verificationModalSource = 'supplier-profile';
			this.verifUser(user);
		},
		openSupplierProfileFromVerification(user) {
			this.closeModalVerification();
			this.openSupplierProfile(user);
		},
		resetSelectedItems() {
			this.selectedItems = [];
		},
		appendSelectedItems(user) {
			if (user._id) {
				this.selectedItems.push(user._id);
			}
		},
		changeSingleUserStatus(user) {
			this.resetSelectedItems();
			this.appendSelectedItems(user);
			this.isShowChangeStatus = true;
		},
		changeSingleUserPassword(user) {
			this.resetSelectedItems();
			this.appendSelectedItems(user);
			this.selectedPassword = '';
			this.isShowChangePassword = true;
		},
		updateSingleUserFeatures(user) {
			this.resetSelectedItems();
			this.appendSelectedItems(user);
			if (this.selectedItems[0]) {
				this.openModalUpdateFeatures(this.selectedItems[0]);
			}
		},
		copyUserId(user) {
			copyToClipboard(user?._id);

			this.$notify({
				group: 'app',
				title: 'User ID Copied',
				text: user?._id,
				type: 'success',
			});
		},
		toggleStoreStatusModal(item = null, modalState = true, storeStatusState = 'close', isBulk = false) {
			this.isStoreStatusModalVisible = modalState;
			this.storeStatusState = storeStatusState;
			this.selectedItem = item;
			this.isBulkUpdateStoreStatus = isBulk;
		},
		toggleProductStatusModal(item = null, modalState = true, storeStatusState = 'close', isBulk = false) {
			this.isProductStatusModalVisible = modalState;
			this.productStatusState = storeStatusState;
			this.selectedItem = item;
			this.isBulkUpdateProductStatus = isBulk;
		},
		updateExistingStoreStatus() {
			if (this.isBulkUpdateStoreStatus) {
				const userIds = this.selectedItems.slice();
				if (userIds?.length > 0) {
					userIds.forEach((userId) => {
						const index = this.items.findIndex(item => item._id === userId);
						if (index !== -1) {
							this.items[index].store_availability = this.storeStatusState === 'open';
						}
					});
				}
			} else {
				const userId = this.selectedItem?._id;
				const index = this.items.findIndex(item => item._id === userId);
				if (index !== -1) {
					this.items[index].store_availability = this.storeStatusState === 'open';
				}
			}
		},
		updateStoreStatus() {
			this.isUpdatingStoreStatus = true;

			let userIds = [this.selectedItem?._id];
			if (this.isBulkUpdateStoreStatus) {
				userIds = this.selectedItems.slice();
			}

			const userIdsString = JSON.stringify(userIds);

			const params = {
				user_ids: userIdsString,
				status: this.storeStatusState,
			};

			const callback = (response) => {
				const message = response?.message || 'Success';
				this.$notify({
					group: 'app',
					title: 'Update Store Status',
					text: message,
					type: 'success',
				});

				this.isUpdatingStoreStatus = false;
				this.updateExistingStoreStatus();
				this.toggleStoreStatusModal(null, false);
			};

			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					title: 'Update Store Status',
					text: message || 'Failed',
					type: 'error',
				});

				this.isUpdatingStoreStatus = false;
			};

			bulkUpdateStoreStatus(params, callback, errorCallback);
		},
		updateExistingProductStatus(state) {
			if (this.isBulkUpdateProductStatus) {
				const userIds = this.selectedItems.slice();
				if (userIds?.length > 0) {
					userIds.forEach((userId) => {
						const index = this.items.findIndex(item => item._id === userId);
						if (index !== -1) {
							this.items[index].product_availability = state === 'active';
							this.items[index].is_active = state === 'active';
						}
					});
				}
			} else {
				const userId = this.selectedItem?._id;
				const selectedIndex = this.items.findIndex(item => item._id === userId);
				const selectedUser = this.items[selectedIndex];
				if (selectedUser) {
					selectedUser.product_availability = state === 'active';
					selectedUser.is_active = state === 'active';
					this.items[selectedIndex] = selectedUser;
				}
			}
		},
		updateProductStatus() {
			this.isUpdatingProductStatus = true;

			let userIds = [this.selectedItem?._id];
			if (this.isBulkUpdateProductStatus) {
				userIds = this.selectedItems.slice();
			}

			const params = {
				user_ids: userIds.join(','),
				status: this.productStatusState,
			};

			const callback = (response) => {
				const isSaved = response?.data?.length > 0 ?? false;
				const message = response?.message || 'Success';
				this.$notify({
					group: 'app',
					title: 'Update Product Status',
					text: message,
					type: 'success',
				});

				this.isUpdatingProductStatus = false;
				if (isSaved) {
					this.updateExistingProductStatus(this.productStatusState);
				}
				this.toggleProductStatusModal(null, false);
			};

			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					title: 'Update Product Status',
					text: message || 'Failed',
					type: 'error',
				});

				this.isUpdatingProductStatus = false;
			};

			usersApi.suspendProductBulk(params, callback, errorCallback);
		},
		getStoreCity(item) {
			const city = item?.store?.address_detail?.city_name_with_type;
			return city || '-';
		},
	},
	computed: {
		...mapGetters({
			isAdmin: 'isAdmin',
			isSupport: 'isSupport',
			filterDatePresets: 'filterDatePresets',
		}),
		selectAll: {
			get() {
				return this.items
					? this.selectedItems.length === this.items.length
					: false;
			},
			set(value) {
				const selected = [];
				if (value) {
					this.items.forEach((item) => {
						selected.push(item._id);
					});
				}
				this.selectedItems = selected;
			},
		},
		sinceQuery() {
			const since = this.$route.query.since;
			return since;
		},
		untilQuery() {
			const until = this.$route.query.until;
			return until;
		},
		statusParam() {
			return this.$route.query.status;
		},
		isFilterOn() {
			return this.identity_status !== 'all'
				|| this.is_active !== 'all';
		},
		disabledTooltip() {
			return this.selectedItems.length === 0 ? 'Pilih Supplier terlebih dahulu' : '';
		},
		userId() {
			return this.$route?.query?.user_id;
		},
	},
	watch: {
		isAdmin() {
			this.fetchSuppliers();
		},
		'$route.query': {
			handler() {
				this.fetchSuppliers();
			},
		},
	},
	created() {
		this.expirationDate = this.moment().format('YYYY-MM-DD');
		this.initFilterDate();
		// Fetch Packages
		this.fetchPackages();
		// Check Params & Fetch Data
		this.fetchSuppliers();
		// On Scroll Bottom
		window.addEventListener('scroll', this.handleScroll);
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll);
	},
};
</script>

<style lang="scss" scoped>
.capitalize {
	text-transform: capitalize;
}
</style>
